import React from 'react';
import { motion } from 'framer-motion';
const comparisons = [{
  bad: 'Horas buscando actividades',
  good: 'Todo listo para usar'
}, {
  bad: 'Recursos desordenados',
  good: 'Materiales inclusivos profesionales'
}, {
  bad: 'Estrés y agotamiento',
  good: 'Más tiempo y tranquilidad'
}, {
  bad: 'Falta de organización',
  good: 'Mejor acompañamiento para los chicos'
}];
export function FinalCTA() {
  return <section className="w-full bg-[#FFF8F0] py-16 sm:py-24 px-4 overflow-hidden relative" data-id="element-48">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-49">
        <div className="text-center mb-12 sm:mb-16" data-id="element-50">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-[#3D3935] mb-6 max-w-4xl mx-auto leading-tight" data-id="element-51">
            Seguir improvisando materiales… o tener todo listo desde hoy.{' '}
            <span className="text-[#F5A04B]" data-id="element-52">Vos elegís.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-53">
          {/* Comparison Table */}
          <div className="space-y-4" data-id="element-54">
            {comparisons.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} className="flex items-center gap-3 sm:gap-4 bg-white p-4 sm:p-5 rounded-2xl shadow-sm border border-[#EFE3D4]" data-id="element-55">
                <div className="flex-1 text-right" data-id="element-56">
                  <p className="text-[#8B7E76] text-xs sm:text-sm font-semibold line-through" data-id="element-57">
                    {item.bad}
                  </p>
                </div>
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#F5C84B]/20 flex items-center justify-center text-[#F5A04B] font-black" data-id="element-58">
                  →
                </div>
                <div className="flex-1" data-id="element-59">
                  <p className="text-[#3D3935] text-sm sm:text-base font-black" data-id="element-60">
                    {item.good}
                  </p>
                </div>
              </motion.div>)}
          </div>

          {/* Pricing Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-3xl p-6 sm:p-8 shadow-[0_8px_30px_rgba(245,200,75,0.15)] border-2 border-[#F5C84B]/30 relative" data-id="element-61">
            <div className="text-center mb-6" data-id="element-62">
              <h3 className="text-xl sm:text-2xl font-black text-[#3D3935] mb-2" data-id="element-63">
                💛 MEGA PACK INCLUSIVO INFANTIL™
              </h3>
            </div>

            {/* Price Area */}
            <div className="text-center mb-8" data-id="element-64">
              <div className="flex items-center justify-center gap-2 mb-1" data-id="element-65">
                <span className="text-[#8B7E76] line-through text-sm sm:text-base font-bold" data-id="element-66">
                  Antes $79.990
                </span>
                <span className="bg-red-100 text-red-600 text-[10px] sm:text-xs font-black px-2 py-0.5 rounded-md" data-id="element-67">
                  -75%
                </span>
              </div>
              <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-68">
                <span className="font-black text-4xl sm:text-5xl tracking-tight text-[#3D3935]" data-id="element-69">
                  $19.990
                </span>
                <span className="text-[#8B7E76] text-sm font-bold" data-id="element-70">ARS</span>
              </div>
            </div>

            {/* CTA Button */}
            <motion.a href="https://www.iterapro.shop/cart/43354400358489:1" className="btn-brand-pulse relative block w-full text-center bg-gradient-to-b from-[#F5C84B] to-[#F5A04B] text-[#3D3935] font-black text-base sm:text-xl py-5 sm:py-6 rounded-2xl overflow-hidden group shadow-[0_0_40px_rgba(245,200,75,0.3),0_4px_20px_rgba(0,0,0,0.1)] hover:shadow-[0_0_60px_rgba(245,200,75,0.45),0_0_120px_rgba(245,200,75,0.15)]" whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} transition={{
            type: 'spring',
            stiffness: 400,
            damping: 25
          }} data-id="element-71">
              {/* TODO: replace # with real Mercado Pago/Hotmart checkout URL */}
              <div className="absolute inset-0 rounded-2xl border border-white/40 pointer-events-none" data-id="element-72" />
              <div className="absolute inset-x-0 top-0 h-[45%] bg-gradient-to-b from-white/30 to-transparent rounded-t-2xl pointer-events-none" data-id="element-73" />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out pointer-events-none" data-id="element-74" />

              <span className="relative z-10 flex items-center justify-center gap-1.5 sm:gap-2 drop-shadow-[0_1px_1px_rgba(255,255,255,0.5)]" data-id="element-75">
                <span data-id="element-76">👉 SÍ, QUIERO MI MEGA PACK AHORA</span>
                <motion.span className="inline-flex items-center text-base sm:text-xl leading-none -mt-px" animate={{
                x: [0, 5, 0]
              }} transition={{
                duration: 1.2,
                repeat: Infinity,
                ease: 'easeInOut'
              }} data-id="element-77">
                  →
                </motion.span>
              </span>
            </motion.a>

            {/* Local Currency Trust Line */}
            <p className="text-[#8B7E76] text-[11px] sm:text-sm font-bold text-center mt-4" data-id="element-78">
              <span className="inline-flex items-center align-middle mr-1 text-sm leading-none" data-id="element-79">
                🌎
              </span>
              Pagás en pesos argentinos
            </p>
          </motion.div>
        </div>

        {/* Trust Bar */}
        <div className="mt-12 flex flex-wrap justify-center gap-4 sm:gap-8 border-t border-[#EFE3D4] pt-8" data-id="element-80">
          {['🔒 Pago seguro', '⚡ Acceso inmediato', '🛡️ Garantía 7 días', '💳 Mercado Pago · Tarjeta'].map((text, i) => <div key={i} className="flex items-center gap-2 text-[#8B7E76] font-bold text-xs sm:text-sm" data-id="element-81">
              {text}
            </div>)}
        </div>
      </div>
    </section>;
}